import React from 'react';
import { Box, CircularProgress } from '@mui/material';

/**
 * Fallback rendered while a module's chunk is being downloaded.
 *
 * It only covers the content area: the `Suspense` boundary lives inside the
 * layout, so the sidebar and the header stay on screen while this shows.
 */
export function ModuleLoader () {
    return (
        <Box
            minHeight="30.769rem"
            display="flex"
            alignItems="center"
            justifyContent="center"
        >
            <CircularProgress />
        </Box>
    );
}
